var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployee8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#53E7E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9565 25L15.9125 21.29H15.3385V25H12.9445V15.172H16.9625C17.7372 15.172 18.3952 15.3073 18.9365 15.578C19.4872 15.8487 19.8978 16.222 20.1685 16.698C20.4392 17.1647 20.5745 17.6873 20.5745 18.266C20.5745 18.9193 20.3878 19.5027 20.0145 20.016C19.6505 20.5293 19.1092 20.8933 18.3905 21.108L20.6585 25H17.9565ZM15.3385 19.596H16.8225C17.2612 19.596 17.5878 19.4887 17.8025 19.274C18.0265 19.0593 18.1385 18.756 18.1385 18.364C18.1385 17.9907 18.0265 17.6967 17.8025 17.482C17.5878 17.2673 17.2612 17.16 16.8225 17.16H15.3385V19.596ZM24.6113 17.09V19.078H27.8173V20.926H24.6113V23.082H28.2373V25H22.2173V15.172H28.2373V17.09H24.6113Z",
    fill: "#D8ACFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee8);
export default __webpack_public_path__ + "static/media/employee8.82f5cbbdc0368b8ae7340b05751fefdc.svg";
export { ForwardRef as ReactComponent };